import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { isEligibleForSummer2022RetailPromotionSelector } from '../../selectors/PromotionSelectors';
import { isRussianBlockedSelector } from '../../selectors/PurchaseMotionSelectors';
import RussianBlockedBanner from './RussianBlockedBanner';
import StarterSuiteRetailPromotionBanner from './StarterSuiteRetailPromotionBanner';

const BannerHierarchySection = ({
  screen
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const shouldShowStarterSuitePromoBanner = useSelector(state => {
    if (hasPricingAndPurchasingSucceeded) {
      return isEligibleForSummer2022RetailPromotionSelector(state);
    }

    return false;
  });
  const isRussianBlocked = useSelector(isRussianBlockedSelector);

  if (!hasPricingAndPurchasingSucceeded) {
    return null;
  }

  if (isRussianBlocked) {
    return /*#__PURE__*/_jsx(RussianBlockedBanner, {});
  }

  if (shouldShowStarterSuitePromoBanner) {
    return /*#__PURE__*/_jsx(StarterSuiteRetailPromotionBanner, {
      screen: screen
    });
  }

  return null;
};

export default BannerHierarchySection;